
  <div *ngIf="!readonly && !baseProps?.readonly">
    <shared-add-note-form
      [newMessage]="newMessage"
      [disabled]="disabled || editingNoteId !== null"
      [showVisibilityToggle]="false"
      placeholder="Add Note"
      (clearClicked)="clearNote()"
      (saveClicked)="addNote($event)"
      (messageChanged)="newMessage = $event">
    </shared-add-note-form>
  </div>

<ul #notesList class="task-notes-list">
  <li *ngIf="notes.length == 0">No Notes Added</li>
  <li *ngFor="let note of notes" class="note" [attr.id]="'note-' + note.id" tabindex="-1">
    <div class="details">
      <div class="message-row d-flex flex-row justify-content-between" *ngIf="editingNoteId !== note.id">
        <div class="message flex-grow-1"
          [class.message-condensed]="updatedRequirementTaskNoteStyling && !isNoteExpanded(note.id)"
          [id]="'message-' + note.id"
          [innerHtml]="displayMessage(note.message)"></div>
        <button class="btn btn-link btn-sm flex-shrink-0 custom" style="font-size: 14px !important;align-self: flex-start;"
          *ngIf="canEditNote(note)" (click)="editNote(note)" [disabled]="disableEditNote(note)">Edit</button>
      </div>
      @if (updatedRequirementTaskNoteStyling) {
        <div class="note-expand-link" [id]="'expand-' + note.id" style="display: none;">
          <a class="btn-link-more" (click)="toggleNoteExpanded(note.id)">
            <mat-icon svgIcon="plus" *ngIf="!isNoteExpanded(note.id)" style="margin-bottom: 6px;"></mat-icon>
            <mat-icon svgIcon="minus" *ngIf="isNoteExpanded(note.id)" style="margin-bottom: 6px;"></mat-icon>
            {{ isNoteExpanded(note.id) ? 'See Less' : 'See More' }}
          </a>
        </div>
      }
      <div *ngIf="editingNoteId === note.id">
        <div class="add-note-form flex flex-row" >
          <app-rich-text-editor [(ngModel)]="editedMessage" placeholder="Edit note..." minHeight="100px" class="text-area-container">
          </app-rich-text-editor>        
          <div id="divEditNoteButtons" class="action-button-container" *ngIf="editingNoteId === note.id">
            <ng-container>
              <button mat-flat-button style="background-color: transparent" (click)="discardEdit()">Discard</button>
              <button mat-stroked-button color="primary" (click)="saveNote(note)" [disabled]="editedMessage === ''">Save</button>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-between align-items-center note-meta">
        <div>
          <span class="note-author">{{ note.userDisplayName || note.createdBy }}</span>
          <span class="note-role">{{ note.userRole }}</span>
        </div>
        <span class="note-date">{{ note.updatedOnDisplay || note.createdOnDisplay || (note.createdOn | date:'M/d/yyyy h:mm a') }}</span>
      </div>
    </div>
  </li>
</ul>